/* dl-tolomeo.js — šablona product.tolomeo (sekce dl-tol-pdp)
   1) galerie: fotka zvolené varianty první, fotky ostatních variant mimo DOM
   (výkres rozměrů řeší jednotně snippets/dl-dims-swap.liquid)
   3) piktogramy u volby Uchycení
   4) řádek Sestava: z jakých dílů se varianta skládá (kódy z SKU)
   Poslouchá událost dl:variant z dl-product.js; první stav si načte sám. */
(function () {
  var dataEl = document.getElementById('dl-tol-data');
  var root = document.querySelector('[data-dl-product]');
  if (!dataEl || !root) return;
  var D, P;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  try { P = JSON.parse(root.querySelector('[data-dl-payload]').textContent); } catch (e) { return; }
  var V = P.variants || [], byId = {};
  V.forEach(function (v) { byId[v.id] = v; });

  /* ---------- 1) galerie ---------- */
  var gal = root.querySelector('.gal'), wrap = root.querySelector('.galwrap');
  var store = {}, capN = 0;
  if (gal) {
    var vm = {};
    V.forEach(function (v) { if (v.media != null) vm[v.media] = 1; });
    var cells = Array.prototype.slice.call(gal.querySelectorAll('.sh'));
    var over = cells.filter(function (c) { return c.classList.contains('over'); }).length;
    if (over) capN = cells.length - over;
    cells.forEach(function (c) { var p = +c.getAttribute('data-media'); if (vm[p]) store[p] = c; });
  }
  function arrange(v) {
    if (!gal || !Object.keys(store).length) return;
    var cur = v && v.media != null ? store[v.media] : null;
    Object.keys(store).forEach(function (k) {
      var c = store[k];
      if (c !== cur && c.parentNode) c.parentNode.removeChild(c);
    });
    if (cur) { gal.insertBefore(cur, gal.firstChild); cur.classList.add('on'); }
    var cs = gal.querySelectorAll('.sh'), n = cs.length;
    if (capN && gal.classList.contains('cap')) {
      Array.prototype.forEach.call(cs, function (c, i) { c.classList.toggle('over', i >= capN); });
      var more = root.querySelector('[data-dl-galmore]');
      if (more) {
        if (n <= capN) { more.hidden = true; gal.classList.remove('cap'); }
        else if (more.firstChild && more.firstChild.nodeType === 3) more.firstChild.nodeValue = more.firstChild.nodeValue.replace(/\d+/, n);
      }
    }
    var dc = n >= 5 ? 'many' : String(n);
    gal.setAttribute('data-count', dc);
    if (wrap) wrap.setAttribute('data-count', dc);
    if (window.matchMedia('(max-width:900px)').matches && gal.scrollLeft) gal.scrollTo({ left: 0 });
  }

  /* ---------- 3) piktogramy ---------- */
  var I = {
    'stolní podstavec': '<path d="M3 21h18"/><path d="M7 21v-2h7v2"/><path d="M10.5 19 8.5 10l7-5"/><path d="M15.5 5l3.5 1.5-2 3.5z"/>',
    'úchytka z boku stolu': '<path d="M2 11h11v3H2"/><path d="M13 9.5h2.5v6H13"/><path d="M14 9.5 12 4l6-2"/><path d="M18 2l3 1.5-2 3z"/><path d="M14.3 15.5V19"/>',
    'úchytka do desky stolu': '<path d="M2 12h20v3H2z"/><path d="M10 12V17.5"/><path d="M10 12 8 5l7-3"/><path d="M15 2l3.5 1.5-2 3.5z"/>',
    'nástěnná úchytka': '<path d="M4 2v20"/><path d="M4 10h2.5v4H4"/><path d="M6.5 12 13 6l6 3"/><path d="M19 9l2.5 2.5-3.5 1.5z"/>',
    'stojací (terra)': '<path d="M3 22h18"/><path d="M8 22h7"/><path d="M11.5 22V7"/><path d="M11.5 7 17 3.5"/><path d="M17 3.5l3.5 1.5-2 3z"/>',
    'čtecí stojací (lettura)': '<path d="M3 22h18"/><path d="M8 22h7"/><path d="M11.5 22v-9"/><path d="M11.5 13 18.5 6.5"/><path d="M18.5 6.5l2.5 2.5-3.5 1z"/>'
  };
  function icon(label) {
    var l = String(label || '').toLowerCase(), k = null;
    if (l.indexOf('lettura') > -1 || l.indexOf('čtecí') > -1) k = 'čtecí stojací (lettura)';
    else if (l.indexOf('terra') > -1 || l.indexOf('stojací') > -1) k = 'stojací (terra)';
    else if (l.indexOf('nástěnn') > -1) k = 'nástěnná úchytka';
    else if (l.indexOf('boku') > -1) k = 'úchytka z boku stolu';
    else if (l.indexOf('desky') > -1) k = 'úchytka do desky stolu';
    else if (l.indexOf('podstav') > -1) k = 'stolní podstavec';
    return k ? '<svg viewBox="0 0 24 24" aria-hidden="true">' + I[k] + '</svg>' : '';
  }
  var mi = (D.opts || []).indexOf(D.mountOpt || 'Uchycení');
  if (mi > -1) {
    var g = root.querySelector('.ogrid[data-dl-opt="' + mi + '"]');
    if (g) {
      g.classList.add('tol-mnt');
      Array.prototype.forEach.call(g.querySelectorAll('.o'), function (o) {
        var s = icon(o.getAttribute('data-v'));
        if (s && !o.querySelector('svg')) o.insertAdjacentHTML('afterbegin', s);
      });
    }
  }

  /* ---------- 4) sestava ---------- */
  var N = {
    A001000: 'tělo lampy Tolomeo, hliník', A004420: 'tělo lampy Tolomeo, bílá', A004430: 'tělo lampy Tolomeo, černá',
    A013900: 'tělo Tolomeo lettura, hliník', A013930: 'tělo Tolomeo lettura, černá',
    A005910: 'tělo Tolomeo mini, hliník', A005920: 'tělo Tolomeo mini, bílá', A005940: 'tělo Tolomeo mini, černá',
    A010900: 'tělo Tolomeo micro, hliník', '0010920A': 'tělo Tolomeo micro, lesklá bílá', A010930: 'tělo Tolomeo micro, černá',
    A010910: 'tělo Tolomeo micro, červená', A010950: 'tělo Tolomeo micro, modrá', A010960: 'tělo Tolomeo micro, oranžová',
    A004030: 'stolní podstavec Ø 23 cm, hliník', A005320: 'stolní podstavec Ø 23 cm, bílý', A005330: 'stolní podstavec Ø 23 cm, černý',
    A008600: 'stolní podstavec Ø 20 cm, hliník', A008610: 'stolní podstavec Ø 20 cm, černý', A008620: 'stolní podstavec Ø 20 cm, bílý',
    A004100: 'úchytka z boku stolu', A004200: 'úchytka do desky stolu', A025150: 'nástěnná úchytka',
    A012820: 'stojan terra', A043900: 'stojan Tolomeo micro terra', A014900: 'podstavec lettura, hliník', A014930: 'podstavec lettura, černý',
    '0564010A': 'těleso Mega s vypínačem, hliník', '0778010A': 'těleso Mega se stmívačem, hliník',
    '0564030A': 'těleso Mega s vypínačem, černá', '0778030A': 'těleso Mega se stmívačem, černá',
    '0779010A': 'podstavec s tyčí Mega, hliník', '0779030A': 'podstavec s tyčí Mega, černý', '0563050A': 'nástěnná úchytka Mega',
    '0780010A': 'stínidlo pergamen Ø 32 cm', '0780020A': 'stínidlo pergamen Ø 36 cm', '0780030A': 'stínidlo pergamen Ø 42 cm',
    '0780040A': 'stínidlo pergamen Ø 18 cm', '0780060A': 'stínidlo pergamen Ø 52 cm', '0372050A': 'stínidlo pergamen Ø 24 cm',
    '0781010A': 'stínidlo satén Ø 32 cm', '0781020A': 'stínidlo satén Ø 36 cm', '0781030A': 'stínidlo satén Ø 42 cm',
    '0781040A': 'stínidlo satén Ø 18 cm', '0781050A': 'stínidlo satén Ø 24 cm', '0781060A': 'stínidlo satén Ø 52 cm',
    '0772010A': 'stínidlo černá textilie Ø 32 cm', '0772020A': 'stínidlo černá textilie Ø 36 cm', '0772030A': 'stínidlo černá textilie Ø 42 cm',
    '0772040A': 'stínidlo černá textilie Ø 52 cm', '0371050A': 'hliníkový difuzor',
    '0947010A': 'tělo basculante se stínidlem z pergamenu', '0947020A': 'tělo basculante se saténovým stínidlem',
    A014600: 'tělo basculante lettura, pergamen', A014610: 'tělo basculante lettura, satén',
    '0629000A': 'tělo decentrata', '0630010A': 'konstrukce due bracci', '0782010A': 'konstrukce Mega sospensione, hliník',
    '0782030A': 'konstrukce Mega sospensione, černá', '1183010A': 'tělo parete diffusore 18', '1184010A': 'tělo parete diffusore 24',
    '1186010A': 'tělo parete diffusore 32', ZAS: 'provedení s připojením do zásuvky'
  };
  var stock = root.querySelector('[data-dl-stock]'), setEl = null;
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sestava(v) {
    if (!stock || !v) return;
    var codes = String(v.sku || '').split(' - ').map(function (s) { return s.trim(); }).filter(Boolean);
    if (!setEl) { setEl = document.createElement('div'); setEl.className = 'tol-set'; stock.parentNode.insertBefore(setEl, stock.nextSibling); }
    if (codes.length < 2) { setEl.hidden = true; return; }
    setEl.hidden = false;
    setEl.innerHTML = '<b>' + esc(D.setLabel || 'Sestava') + '</b>' + codes.map(function (c) {
      return (N[c] ? esc(N[c]) + ' ' : '') + (c === 'ZAS' ? '' : '<code>' + esc(c) + '</code>');
    }).join(' + ');
  }

  function sync(v) { if (!v) return; arrange(v); sestava(v); }
  root.addEventListener('dl:variant', function (e) { sync(e.detail && e.detail.variant); });
  var vid = root.querySelector('[data-dl-vid]');
  function fromInput() { if (vid) sync(byId[+vid.value] || byId[vid.value]); }
  fromInput();
  if (vid && window.MutationObserver) new MutationObserver(fromInput).observe(vid, { attributes: true, attributeFilter: ['value'] });
})();
